import * as React from "react";
import { ApolloProvider } from "react-apollo";
import client from "./client";

export const wrapRootElement = ({ element }: { element: any }) => (
  <ApolloProvider client={client}>{element}</ApolloProvider>
);
